import { render, staticRenderFns } from "./EventPns.vue?vue&type=template&id=2519b244&"
import script from "./EventPns.vue?vue&type=script&lang=js&"
export * from "./EventPns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports